import { defineComponent } from '~/scripts/utils/alpine'
import { useElementSize } from '~/scripts/composables/useElementSize'

export default defineComponent(() => {
  return {
    init() {
      useElementSize(this.$root.children[0] as HTMLElement, (size) => {
        this.$store.ui.setHeaderHeight(size.height)
      })
    },
  }
})
